/* eslint-disable react-hooks/rules-of-hooks */
import {
  Checkbox as MuiCheckbox,
  FormControlLabel as MuiFormControlLabel,
  CheckboxProps,
  FormControlLabelProps,
} from '@mui/material'
import styled from '@emotion/styled'
import React from 'react'
import { Colors, Typographies, useTypography } from 'src/components/theme'
import omit from 'lodash/omit'

const StyledCheckbox = styled(MuiCheckbox)`
  padding: 8px 9px !important;
`

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  return <StyledCheckbox {...props} />
}

const StyledFormControlLabel = styled(MuiFormControlLabel)`
  :hover {
    &:not(.checked) {
      svg {
        fill: ${Colors.neutral500};
      }
      color: ${Colors.neutral600};
    }
  }

  & svg {
    height: 18px !important;
    width: 18px !important;
  }

  & .MuiFormControlLabel-label {
    ${useTypography(Typographies.text1)}
  }

  & .MuiFormControlLabel-label.Mui-disabled {
    color: ${Colors.textDisabled} !important;
  }

  & .checked,
  & .Mui-checked {
    svg {
      fill: ${Colors.primaryBlue400} !important;
    }
    color: ${Colors.primaryBlue400} !important;
  }
`

type Props = FormControlLabelProps & {
  isChecked?: boolean
}

export const FormControlLabel: React.FC<Props> = (props) => {
  const className = (props.className ?? '') + (props.isChecked ? 'checked' : '')
  // remove this because react gets angry about passing this to the dom
  const labelProps = omit(props, 'isChecked')
  return <StyledFormControlLabel {...labelProps} className={className} />
}
